

import React from "react";

export default function ListIcon() {
  return (
    <svg
  stroke="currentColor"
  fill="currentColor"
  stroke-width="0"
  viewBox="0 0 24 24"
  height="1em"
  width="1em"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="5.94" y="6.42" width="18.06" height="1.75"></rect>
  <rect x="5.94" y="11.71" width="18.06" height="1.75"></rect>
  <rect x="5.94" y="16.99" width="18.06" height="1.75"></rect>
  <circle cx="1.85" cy="7.29" r="1.52"></circle>
  <circle cx="1.85" cy="12.58" r="1.52"></circle>
  <circle cx="1.85" cy="17.87" r="1.52"></circle>
</svg>
  );
}
